import type { IRecognitionStats, IVote } from "@/types"
import { api } from "./api"
import type { IAPIParams } from "./types"
import { generateAPIResource, generateSetupActivity } from "./utils"

export const votesAPI = generateAPIResource<IVote>("/recognition/votes")

export const recognitionSetupAPI = {
  ...generateSetupActivity("/recognition/setup"),
  test: () => api.post("/recognition/setup/test").then((res) => res.data),
}

export async function fetchRecognitionStats(params: IAPIParams = {}) {
  const res = await api.get<IRecognitionStats[]>("/recognition/stats", { params })
  return res.data
}
